export const AGENT_ROW_ZINDEX = 4;
// this is to bring the menu's above the agentRowTitles
export const EVENT_MENU_ZINDEX = AGENT_ROW_ZINDEX + 10000;
export const HEADER_ROW_ZINDEX = AGENT_ROW_ZINDEX + 10000;

export const ANNOTATION_TYPE_GCAL = 'gcal' as const;

export const GOOGLE_CALENDAR = 'Google Calendar';
